import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoMovimientoService } from 'src/app/services/tipo-movimiento.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAddEditComponent } from './modal-add-edit/modal-add-edit.component';

@Component({
  selector: 'app-tipo-movimiento',
  templateUrl: './tipo-movimiento.component.html',
  styleUrls: ['./tipo-movimiento.component.scss'],
  providers: [SecurityService],
})
export class TipoMovimientoComponent implements OnInit {

  @ViewChild(ModalAddEditComponent, { static: true }) modalAddEditMotivo: ModalAddEditComponent

  // Form
  formHeader: FormGroup

  // Data &  Tmp
  listaTipoMovimientos: Array<any> = null
  operacionesList: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private clog: ConsoleService,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private rutService: RutService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private tipoMovimientoService: TipoMovimientoService
  ) {
    this.log = this.clog.log('MOTIVO-INVENTARIO')
  }

  ngOnInit() {
    this.createForm()
    this.loadOperaciones()
  }

  private createForm() {
    this.formHeader = this.fb.group({
      nombre: [''],
    });
  }

  loadOperaciones() {
    this.tipoMovimientoService.GetOperaciones(({ respuesta }) => {
      const { registros } = respuesta
      this.operacionesList = registros
    })
  }

  openModalMotivo() {
    this.modalAddEditMotivo.show()
  }

  buscar() {
    this.listaTipoMovimientos = null
    // this.formValidatorsService.validateAllFormFields(this.formHeader)
    // if (!this.formHeader.valid)
    //   return

    this.tipoMovimientoService.obtenerSegunFiltroNombre(this.formHeader.get('nombre').value, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta

      registros.forEach(tipoMovimiento => {
        const operacionList = this.operacionesList.filter(operacion => operacion.operacion === tipoMovimiento.operacion)
        tipoMovimiento.operacionNombre = (operacionList && operacionList.length > 0) ? operacionList[0].nombre : '--NO MANEJADO--'
      });
      this.listaTipoMovimientos = registros
    })
  }

  editar(tipoMov) {
    this.modalAddEditMotivo.load(tipoMov)
  }

  desactivar({ codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        activo: false
      }
    }
    this.cambiarEstado(inputParams)
  }

  activar({ codigo }) {
    const inputParams = {
      entidad: {
        codigo,
        activo: true
      }
    }
    this.cambiarEstado(inputParams)
  }

  cambiarEstado(inputParams) {
    this.tipoMovimientoService.cambiaEstado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastrService.success('Operación realizada con éxito')
      this.buscar()
    })
  }

  onAddEdit(tipoMov) {
    this.buscar()
  }

}
